<template>
  <div v-if="product.properties.notice" class="container mx-auto px-4">
    <h2 class="text-2xl font-bold mb-6">
      Notice d'utilisation
    </h2>
    <div class="w-full overflow-x-auto">
      <div class="flex" style="min-width: 768px;">
        <div
          v-for="(tile, index) in product.properties.notice.slides"
          :key="index"
          class="w-1/4 mr-3"
        >
          <div class="mb-3 relative">
            <img class="w-full" loading="lazy" :src="`${tile.picture}?format=webp`" :alt="tile.advice">
            <div class="flex text-xs items-center justify-center absolute left-0 bottom-0 bg-sky_grey_darker" style="border-top-right-radius: 10px; height: 23px; width: 23px;">
              {{ index + 1 }}
            </div>
          </div>
          <div class="text-sm px-2">
            {{ tile.advice }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  computed: {
    attributeValue () {
      return this.product.properties.notice
    }
  }
}
</script>
